import botones_logo from "../../../assets/botones-links-pago.webp";
export const Hero = () => {
  return (
    <div className='relative p-0'>
    <div className="overflow-hidden lg:h-[50vh]">
        <img className="translate-y-20 3xs:translate-y-16 2xs:translate-y-12 xs:translate-y-10 sm:translate-y-4 lg:-translate-y-0 w-full h-auto object-contain" id="botones" src= {botones_logo} alt="botones" />
    </div>
    <div className="absolute text-[1rem] xs:text-[2rem] sm:text-[4rem] md:text-[3rem] lg:text-[5rem] xl:text-[4rem] 2xl:text-[6rem] 5xl:text-[7rem] left-[2rem] 2xs:left-[3rem] xs:left-[3rem] sm:left-[2rem] md:left-[5rem]  lg:left-[8rem] xl:left-[8rem] 2xl:left-[2rem] 3xl:left-[6rem] 4xl:left-[8rem] 5xl:left-[4rem] 6xl:left-[8rem] bg-blanco/80 font-bold flex justify-center items-end  z-10 opacity-75 top-[7.7rem]  3xs:top-[8rem] 2xs:top-[8rem] xs:top-[8rem] sm:top-[6rem] md:top-[8rem] 2md:top-[10rem] lg:top-[12rem] xl:top-[12rem] 2xl:top-[18rem] 5xl:top-[15rem] 6xl:top-[16rem] 7xl:top-[24rem] 8xl:top-[30rem]">
    <p className="text-white">Paga tus multas de forma rapida</p>
    </div>
    
</div>
  )
}
